<template>
  <div :class="{'c-topic-wrapper': showHalo}">
    <div class="c-topic-wrapper__circle c-topic-wrapper__circle--1"></div>
    <div class="c-topic-wrapper__circle c-topic-wrapper__circle--2"></div>
    <div class="c-topic-wrapper__circle c-topic-wrapper__circle--3"></div>
    <div class="c-topic-wrapper__circle c-topic-wrapper__circle--4"></div>
    <div class="c-topic-wrapper__circle c-topic-wrapper__circle--5"></div>
    <component
      :is="componentType"
      class="c-topic"
      :class="[statusClass, sizeClass, noOpinionClass, staticClass]"
      :to="to"
    >
      <div class="c-topic__image" v-if="image" :style="{ backgroundImage: 'url(' + image + ')' }"/>
      <div class="c-topic__label">{{ label }}</div>
    </component>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    to: {
      type: String
    },
    size: {
      type: Number,
      default: 0
    },
    status: {
      type: Boolean,
      default: null
    },
    noOpinion: {
      type: Boolean,
      default: false
    },
    image: {
      type: String
    },
    static: {
      default: false
    },
    showHalo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentType () {
      if (typeof this.to === 'undefined') {
        return 'div'
      } else {
        return 'router-link'
      }
    },
    statusClass () {
      if (this.status === true && this.noOpinion === false) {
        return 'c-topic--green'
      } else if (this.status === false && this.noOpinion === false) {
        return 'c-topic--red'
      }
    },
    sizeClass () {
      if (this.size !== 0) {
        return 'c-topic--' + this.size
      }
    },
    noOpinionClass () {
      if (this.noOpinion === true) {
        return 'c-topic--noopinion'
      }
    },
    staticClass () {
      if (this.static === true) {
        return 'c-topic--static'
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables';

.c-topic {
  align-items: center;
  background: $blue;
  background: linear-gradient(to top right, $blue, $blue-gradient);
  border: 3px solid #FFF;
  border-radius: 50%;
  box-shadow: 0 1rem 2.4rem #000;
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  height: 16rem;
  justify-content: center;
  overflow: hidden;
  padding: 1.6rem;
  position: relative;
  transition: transform 0.15s ease-in-out;
  text-align: center;
  width: 16rem;
  will-change: transform;

  &:not(.c-topic--static):hover {
    transform: scale(1.1);
    z-index: 2;
  }
}

.c-topic__image {
  background-position: center center;
  background-size: cover;
  bottom: 0;
  filter: grayscale(1);
  left: 0;
  mix-blend-mode: multiply;
  opacity: 0.2;
  position: absolute;
  right: 0;
  top: 0;
}

.c-topic__label {
  color: #FFF;
  position: relative;
  text-shadow: 0 0.2rem 2.4rem rgba(#000, 0.5);
  z-index: 1;
}

.c-topic--1 {
  font-size: 1.4rem;
  height: 9.6rem;
  line-height: 1.8rem;
  width: 9.6rem;
}

.c-topic--2 {
  font-size: 1.6rem;
  height: 12.8rem;
  line-height: 2rem;
  width: 12.8rem;
}

.c-topic--3 {
  height: 16rem;
  width: 16rem;
}

.c-topic--4 {
  font-size: 2.2rem;
  height: 19.2rem;
  line-height: 2.8rem;
  width: 19.2rem;
}

.c-topic--5 {
  font-size: 2.4rem;
  height: 22.4rem;
  line-height: 3rem;
  width: 22.4rem;
}

.c-topic--green {
  background: $green;
  background: linear-gradient(to bottom right, $green, $green-gradient);
}

.c-topic--red {
  background: $red;
  background: linear-gradient(to bottom right, $red, $red-gradient);
}

.c-topic--noopinion {
  background: #858585;
}

.c-topic-wrapper {
  height: 22.4rem;
  position: relative;
  width: 22.4rem;

  .c-topic {
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
  }

  .c-topic-wrapper__circle {
    border: 1px solid rgba(#FFF, 0.2);
    border-radius: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
  }

  .c-topic-wrapper__circle--1 {
    height: 9.6rem;
    width: 9.6rem;
  }

  .c-topic-wrapper__circle--2 {
    height: 12.8rem;
    width: 12.8rem;
  }

  .c-topic-wrapper__circle--3 {
    height: 16rem;
    width: 16rem;
  }

  .c-topic-wrapper__circle--4 {
    height: 19.2rem;
    width: 19.2rem;
  }

  .c-topic-wrapper__circle--5 {
    height: 22.4rem;
    width: 22.4rem;
  }
}

@supports (mix-blend-mode: multiply) {
  .c-topic__image {
    opacity: 0.4;
  }
}

@media (max-width: $bp-medium) {
  .c-topic {
    font-size: 1.6rem;
    height: 13.6rem;
    line-height: 2.1rem;
    width: 13.6rem;
  }

  .c-topic--1 {
    font-size: 1rem;
    height: 7.2rem;
    line-height: 1.3rem;
    width: 7.2rem;
  }

  .c-topic--2 {
    font-size: 1.4rem;
    height: 10.4rem;
    line-height: 1.8rem;
    width: 10.4rem;
  }

  .c-topic--3 {
    height: 13.6rem;
    width: 13.6rem;
  }

  .c-topic--4 {
    font-size: 2.2rem;
    height: 16.8rem;
    line-height: 2.8rem;
    width: 16.8rem;
  }

  .c-topic--5 {
    font-size: 2.4rem;
    height: 20rem;
    line-height: 3rem;
    width: 20rem;
  }
}
</style>
